<perfect-scrollbar
  class="fixed custom-scrollbar side-nav top-[48px] pl-4 pr-2 border-r border-[#edf2f9] dark:border-transparent h-full z-[1000] transition-all duration-200 ease-in-out bg-gray-950 dark:bg-[#1b1d2a]"
  sideNav
>
  <ul
    *ngFor="let itemGroup of menuItems"
    class="bg-gray-800 rounded-xl text-white border-none dark:bg-[#1b1d2a] ant-menu ant-menu-root ant-menu-inline side-nav-menu"
    [ngClass]="{
      'ant-menu-inline-collapsed': isFolded,
      'ant-menu-dark': isSideNavDark
    }"
  >
    <li
      [ngClass]="
        item.submenu.length > 0
          ? 'ant-menu-submenu ant-menu-submenu-inline rounded-LG'
          : 'ant-menu-item rounded-lg'
      "
      *ngFor="let item of itemGroup"
      [routerLinkActive]="
        item.submenu.length > 0
          ? 'ant-menu-submenu-open'
          : 'ant-menu-item-selected bg-yellow-500'
      "
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <a
        class="text-white"
        class="ant-menu-submenu-title"
        *ngIf="item.submenu.length > 0"
      >
        <i
          class="text-white"
          *ngIf="item.iconType == 'nzIcon'"
          nz-icon
          [nzType]="item.icon"
          [theme]="item.iconTheme"
        ></i>
        <i
          class="text-white"
          *ngIf="item.iconType == 'fontawesome'"
          class="me-[10px]"
          [ngClass]="[item.iconTheme, item.icon]"
        ></i>
        <span class="text-white" [translate]="item.title"> </span>
        <i class="ant-menu-submenu-arrow"></i>
      </a>
      <a
        class="text-white"
        [routerLink]="item.path"
        (click)="closeMobileMenu()"
        *ngIf="item.submenu.length === 0"
      >
        <i
          class="text-white"
          *ngIf="item.iconType == 'nzIcon'"
          nz-icon
          [nzType]="item.icon"
          [theme]="item.iconTheme"
        ></i>
        <i
          class="text-white"
          *ngIf="item.iconType == 'fontawesome'"
          class="me-[10px]"
          [ngClass]="[item.iconTheme, item.icon]"
        ></i>
        <span class="text-white" [translate]="item.title"></span>
      </a>
      <!-- Second Level -->
      <ul
        class="text-white bg-gray-800 ant-menu ant-menu-inline ant-menu-sub dropdown-menu"
        *ngIf="item.submenu.length > 0"
      >
        <li
          [ngClass]="
            subItem.submenu.length > 0
              ? 'ant-menu-submenu ant-menu-submenu-inline rounded-lg'
              : 'ant-menu-item rounded-lg'
          "
          *ngFor="let subItem of item.submenu"
          [routerLinkActive]="
            subItem.submenu.length > 0
              ? 'ant-menu-submenu-open'
              : 'ant-menu-item-selected bg-yellow-500'
          "
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a
            class="ant-menu-submenu-title text-white"
            *ngIf="subItem.submenu.length > 0"
          >
            <i
              class="text-white"
              *ngIf="subItem.iconType == 'nzIcon'"
              nz-icon
              [nzType]="subItem.icon"
              [theme]="subItem.iconTheme"
            ></i>
            <i
              class="text-white"
              *ngIf="subItem.iconType == 'fontawesome'"
              class="me-[10px]"
              [ngClass]="[subItem.iconTheme, subItem.icon]"
            ></i>
            <span class="text-white" [translate]="subItem.title"></span>
            <i class="ant-menu-submenu-arrow"></i>
          </a>
          <a
            [routerLink]="subItem.path"
            (click)="closeMobileMenu()"
            *ngIf="subItem.submenu.length === 0"
          >
            <i
              class="text-white"
              *ngIf="subItem.iconType == 'nzIcon'"
              nz-icon
              [nzType]="subItem.icon"
              [theme]="subItem.iconTheme"
            ></i>
            <i
              *ngIf="subItem.iconType == 'fontawesome'"
              class="me-[10px] text-white"
              [ngClass]="[subItem.iconTheme, subItem.icon]"
            ></i>
            <span class="text-white" [translate]="subItem.title"></span>
          </a>

          <!-- Third Level -->
          <ul
            class="bg-gray-800 ant-menu ant-menu-inline ant-menu-sub dropdown-menu"
            *ngIf="subItem.submenu.length > 0"
          >
            <li
              [ngClass]="
                subItem.submenu.length > 0
                  ? 'ant-menu-submenu ant-menu-submenu-inline rounded-lg'
                  : 'ant-menu-item rounded-lg'
              "
              *ngFor="let subItem of subItem.submenu"
              routerLinkActive="ant-menu-item-selected bg-yellow-500"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <a
                class="ant-menu-submenu-title"
                *ngIf="subItem.submenu.length > 0"
              >
                <i
                  class="text-white"
                  *ngIf="subItem.iconType == 'nzIcon'"
                  nz-icon
                  [nzType]="subItem.icon"
                  [theme]="subItem.iconTheme"
                ></i>
                <i
                  c
                  *ngIf="subItem.iconType == 'fontawesome'"
                  class="me-[10px] text-white"
                  [ngClass]="[subItem.iconTheme, subItem.icon]"
                ></i>
                <span class="text-white" [translate]="subItem.title"></span>
                <i class="ant-menu-submenu-arrow"></i>
              </a>
              <a
                [routerLink]="subItem.path"
                (click)="closeMobileMenu()"
                *ngIf="subItem.submenu.length === 0"
              >
                <i
                  class="text-white"
                  *ngIf="subItem.iconType == 'nzIcon'"
                  nz-icon
                  [nzType]="subItem.icon"
                  [theme]="subItem.iconTheme"
                ></i>
                <i
                  *ngIf="subItem.iconType == 'fontawesome'"
                  class="me-[10px] text-white"
                  [ngClass]="[subItem.iconTheme, subItem.icon]"
                ></i>
                <span class="text-white">{{ subItem.title }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</perfect-scrollbar>
